<script>
    import { profileData } from '../../../store';
    
    /* 
    // Not in use right now.
    function convertTimestamp() {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const date = new Date($profileData.joined.seconds * 1000);

        return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()} / ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
    }
    */

</script>

<style lang="scss" src="./ProfileHeader.scss"></style>

<div class="profileheader">
    <div class="profileheader__media">
        <img class="profileheader__image"src={ $profileData?.picture } alt="user avatar">
    </div>
    <div class="profileheader__text">
        <span class="profileheader__name">{$profileData?.name}</span>
        <span class="profileheader__email">{$profileData?.email}</span>
    </div>
    <!--
        <div class="profileheader__actions">
            TODO - E.g. Button to edit the profile.
        </div>
    -->
</div>